import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ESocialType } from '../../../../types/social';
export var SOCIALS_SETTINGS_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ESocialType.VK, {
  icon: require('../../icons/vk.svg'),
  title: 'ВКонтакте'
}), ESocialType.Facebook, {
  icon: require('../../icons/facebook.svg'),
  title: 'Facebook'
}), ESocialType.Google, {
  icon: require('../../icons/google.svg'),
  title: 'Google'
}), ESocialType.OK, {
  icon: require('../../icons/ok.svg'),
  title: 'Одноклассники'
}), ESocialType.MailRu, {
  icon: require('../../icons/mailru.svg'),
  title: 'Почта Mail.Ru'
}), ESocialType.AppleID, {
  icon: require('../../icons/apple.svg'),
  title: 'Apple ID'
}), ESocialType.Gosuslugi, {
  icon: require('../../icons/gosuslugi.svg'),
  title: 'Госуслуги'
});